export default "__VITE_ASSET__BksXaZj$__"